import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-demo-banner',
    imports: [RouterLink],
    templateUrl: './demo-banner.component.html',
    styleUrl: './demo-banner.component.scss'
})
export class DemoBannerComponent {

}
